export default __webpack_public_path__ + "static/SpaceGrotesk-Regular-3683ead52440efaeba4d929fd19bc02d.ttf";